import { Trad } from "src/components";

export const getGroupedProducts = (products: any[]): any[][] => {
    let groupedProducts: any[][] = products.reduce((total: any, current) => {
        let last = total[total.length - 1];

        if (!last || last[0].ID_TipoProdotto !== current.ID_TipoProdotto) {
            total.push([current]);
        } else {
            last.push(current);
        }
        return total;
    }, []);

    return (groupedProducts = groupedProducts.sort((a, b) =>
        `${Trad.Trad(a[0].TipoRamo)} - ${Trad.Trad(a[0].TipoProdotto)}` < `${Trad.Trad(b[0].TipoRamo)} - ${Trad.Trad(b[0].TipoProdotto)}` ? -1 : 1
    ));
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/CompanyProducts/helpers.ts